<template>
	<nk-dropdown v-model="localValue" @update:modelValue="valueChanged" :options="dropdownOptions" :disabled="disabled ? true : null" ref="input" :tabindex="tabindex"></nk-dropdown>
</template>
<script>
	import _ from 'lodash'
	import { mapGetters } from 'vuex'
	import { post } from '~/plugins/nikan-api'
	import Table from '~/components/table/grid'
	import ProductList from '~/views/sale/products/product-list'
	import $sc from '~/plugins/shortcut.collection.js'
	import Endpoints from '@nikan/endpoints'
	import ProductAdvanceName from '~/components/form/product/product-advance-name'
	import ProductModify from '@/views/sale/products/product-modify'

	export default {
		props: {
			modelValue: {},
			options: {},
			disabled: { type: Boolean, default: false },
			tabindex: {},
			kind: null,
		},
		emits: ['update:modelValue'],
		data() {
			return {
				dropdownOptions: {
					includeDisableProducts: false,
					rowIdentifier: 'id',
					loadOnMount: false,
					display: (item) => {
						if (this.options.displayFields) {
							let val = ''
							for (var i = 0; i < this.options.displayFields.length; i++) {
								let p = item[this.options.displayFields[i]]
								if (Array.isArray(p)) {
									val += p.map(x => x.code).join(',') + ' - '
								} else if (p)
									val += p + ' - '
							}
							if (val.length > 2) {
								val = val.substring(0, val.length - 2)
							}
							return val
						} else {
							if (item.code)
								return `${item.code} - ${item.name}`
						}
						return ''
					},
					remoteSearch: false,
					placeholder: this.$t('search'),
					selectorWidth: '400px',
					selectorHeight: '50%',
					searchRequestFilter: this.prepareFilterObject,
					onDestroyWithText: (dd, text) => {
						// this.findAccount(dd, text);
					},
					component: {
						type: 'ag-grid',
						options: {
							id: this.$options.name,
							rowSelection: {
								mode: 'singleRow'
							},
							paginationPageSize: 50,
							rowModelType: 'serverSide',
							serverInfo: {
								api: {
									url: Endpoints.getUrl('sale.product.paged-list'),
									manipulateResponse: (res) => {
										return {
											rowData: res.data.items,
											rowCount: res.data.totalCount
										}
									},
									manipulateRequest: (params, data) => {
										if (this.dropdownOptions.kind) data.kind = this.dropdownOptions.kind
										data.searchValue = data.filter.searchTerm || data.filter.name || (data.filter.code ? String(data.filter.code) : null)
										data.includeDisableProducts = this.dropdownOptions.includeDisableProducts
										data.searchFields = this.dropdownOptions.serverSearchFields || ['code', 'name']
										return {
											payload: data
										}
									}
								},
								finally: () => {
								},
								searchableFields: ['code', 'name'],
								serverSearchFields: ['code', 'name'],
								payload: {
									includeFloatingJsons: true,
									includeProductUnits: true,
									includeSalePoints: true,
									includePrices: true,
									includeBarcodes: true,
								},
							},
							cellSelectionAggReport: false,
							sideBar: 'none',
							enterToSelect: true,
							doubleClickedToSelect: true,
							pagination: false,
							fitToWidth: false,
							defaultColDef: {
								floatingFilter: false,
								filter: false
							},
							columnDefs: [

								{
									field: 'code',
									headerName: this.$t('sale.product.f.code'),
									width: 120,
									filter: false,
								},
								{
									field: 'name',
									headerName: this.$t('sale.product.f.name'),
									contentType: 'enum',
									valueFormatter: data => data.value,
									cellRenderer: ProductAdvanceName,
									cellRendererParams: (data) => {
										return {
											options: {
												advance: true,
												data: data.data,
												factorType: this.factorType,

											}
										}
									},
									width: 200,
									filter: false,

								}
							],

						},

					},
					buttons: [{
						title: this.$t('list'),
						shortcut: $sc.find('enter'),
						isPrimary: false,
						element: () => { return this.$el },
						icon: 'list-ul',
						handle: (button, page, e) => {
							this.showProducts()
						}
					}, {
						title: this.$t('sale.product.insert'),
						shortcut: $sc.find('ctrl-insert'),
						isPrimary: false,
						element: () => { return this.$el },
						icon: 'plus',
						handle: (button, page, e) => {
							this.showProductModify(null)
						},
						policyClaims: 'Product_Product_Add'
					}]
				},
				localValue: null,
				searchFields: this.options.searchFields,
				displayFields: this.options.displayFields
			}
		},
		computed: {
			...mapGetters({}),
			dropdownValue: {
				get() {
					return this.localValue
				},
				set(val) {
					this.valueChanged(val)
					this.localValue = val
				}
			},
			factorType() {
				return this.dropdownOptions.factorType || 'sale'
			}
		},
		watch: {
			modelValue: {
				handler(val, oldVal) {
					this.localValue = val
				}
			},
			options: {
				immediate: true,
				deep: true,
				handler(val) {
					this.dropdownOptions = _.extend({}, this.dropdownOptions, val)
				}
			}
		},
		created() {
			this.localValue = this.modelValue
		},
		mounted() {
		},
		methods: {
			valueChanged(val) {
				if (val) {
					// we should clear order points to prevent account group issue
					val.orderPoints = []
				}

				this.$emit('update:modelValue', val)
				if (typeof this.options.onChangeHandler === 'function')
					this.options.onChangeHandler(val)
			},
			showProductModify(productInfo) {
				this.showModal({ component: ProductModify, data: productInfo })
					.then((response) => {
						this.getProductByCode(response.code).then(result => {
							this.dropdownValue = result.data
							if (typeof this.options.onChangeHandler === 'function')
								this.options.onChangeHandler(result.data)
							this.$refs.input.focusAndSelect()
						})
					})
					.catch(() => {
					})
			},
			getProductByCode(productCode) {
				return post(Endpoints.getUrl('sale.product.get'), { code: productCode })
			},
			showProducts() {
				var that = this

				this.showModal({ component: ProductList, data: this.dropdownValue, options: { filterType: 'leaves', includeDisableProducts: this.dropdownOptions.includeDisableProducts } })
					.then(async (result) => {
						let wait = this.$wait(this.$el, { size: 'small' })
						await that.getProductByCode(result.code).then(result => {
							this.dropdownValue = result.data
							if (typeof this.options.onChangeHandler === 'function')
								this.options.onChangeHandler(result.data)
						})
						wait.end()
						this.$refs.input.focusAndSelect()
					})
					.catch(() => { })
					.finally(() => { })
			},
			prepareFilterObject(selectedItem, defaultObject) {
				//because of every time entring to cell in edit mode, call url occures, we must set keyword smartly for load already selected item
				if (!defaultObject.keyword && this.searchFields.length > 0 && _.has(selectedItem, 'code')) {
					defaultObject.keyword = selectedItem[this.searchFields[0].toLowerCase()]
				}

				let filters = {}
				for (var i = 0; i < this.searchFields.length; i++) {
					filters[this.searchFields[i]] = defaultObject.keyword
				}
				filters.includeFloatingJsons = this.options.includeFloatingJsons || false
				return filters
			}
		},
	}
</script>
<style></style>
